import { createNanoEvents, Emitter, Unsubscribe } from "nanoevents";

export type EventsEmitter = Emitter;

export type EventsUnsubscriber = Unsubscribe;

export function createEvents(): EventsEmitter {
  return createNanoEvents();
}
